import { defineComponent as _defineComponent } from 'vue'
import { type SectionType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'MetricSection',
  props: {
    sections: null
  },
  setup(__props: any) {

const props = __props as {
  sections: SectionType[]
};



function getSectionLabel(e: SectionType) {
  return (e && e.taxonomy && e.taxonomy.label != null && e.label != null)
    ? `${e.taxonomy.label}/${e.label}`
    : ''
}

return { __sfc: true,props, getSectionLabel }
}

})